import React from 'react';
import ReactDOM from 'react-dom';
import i18n from 'i18n';
import { I18nextProvider } from 'react-i18next';
import { ConfigProvider } from 'antd';
import { localizationConstants, commonConstants } from 'constants/index';
import { localizationHelpers, iframeHelpers } from 'helpers';
import App from './App';
import * as serviceWorker from './serviceWorker';
import { Provider } from 'react-redux';
import store from './reduxs/store';
import TekoID from 'teko-oauth2';
import { isMobileOnly } from 'react-device-detect';
import { PATH } from './routes/constants';

const { getClientId, getOAuthDomain } = iframeHelpers;

const { REGIONS } = localizationConstants;
const { getCurrentLanguage } = localizationHelpers;
const { IAM_SCOPES } = commonConstants;

if (window.location.pathname !== '/loginSuccess') {
  sessionStorage.setItem('lastPath', window.location.pathname);
}

TekoID.init({
  clientId: getClientId(),
  scopes: IAM_SCOPES,
  oauthDomain: getOAuthDomain(),
}).then(() => {
  // The initial phase is finish.
  let isMobilePath = false;
  PATH.MOBILE.forEach(reg => {
    if (!isMobilePath && reg.test(window.location.pathname))
      isMobilePath = true;
  });
  if (isMobileOnly && !isMobilePath) {
    window.location.href = '/mobile';
  } else {
    ReactDOM.render(
      <I18nextProvider i18n={i18n}>
        <Provider store={store}>
          <ConfigProvider locale={REGIONS[getCurrentLanguage()].antdLocale}>
            <App />
          </ConfigProvider>
        </Provider>
      </I18nextProvider>,
      document.getElementById('root')
    );
  }
});

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
